// extracted by mini-css-extract-plugin
export default {"xs-max":"767","sm-max":"992","md-max":"1465","lg-max":"1511","xl-max":"1800","densoButton":"button_densoButton__Hr579"};